import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {CommonService} from '../../../../services/common.service';
import {ConsentsFormService} from '../../../../services/consents-form.service';
import {ToastMessagesService} from '../../../../services/toast-messages.service';
import {ConfirmDialogComponent} from '../../../shared/confirm-dialog/confirm-dialog.component';
import {StudentsDialogComponent} from '../students-dialog/students-dialog.component';

@Component({
    selector: 'app-form-card',
    templateUrl: './form-card.component.html',
    styleUrls: ['./form-card.component.scss']
})
export class FormCardComponent implements OnInit {
    @Input() form: any;
    @Input() mode: number; // 0 Consent - 1 Affirmation - 2 Announcement
    @Output() deleteFormEmit: EventEmitter<any> = new EventEmitter<any>();
    @Output() duplicateFormEmit: EventEmitter<any> = new EventEmitter<any>();

    constructor(public dialog: MatDialog,
                public router: Router,
                private consentsFormService: ConsentsFormService,
                public toastMessagesService: ToastMessagesService,
                private commonService: CommonService) {
    }

    ngOnInit(): void {
        if (this.form.form_type_id !== 3) {
            this.form.createdByFirstName = this.form.created_by_first_name;
            this.form.createdByLastName = this.form.created_by_last_name;
            this.form.date_created = this.form.created_at;
        }
    }

    async showConsentForm(form: any) {
        console.log(form);
        if (form.form_type_id === 3) {
            const inputConfig = {
                parentId: null,
                childId: null,
                mode: 'display',
                unique_id: form.unique_id
            };
            await this.router.navigate(['/home/consentForm'], {queryParams: inputConfig});
        } else {
            await this.showCustomForm(form);
        }
        // const inputConfig = {
        //     parentId: null,
        //     childId: null,
        //     mode: 'display',
        //     unique_id: form.unique_id
        // };
        // if (form.form_type_id === 2) {
        //
        //     await this.router.navigate(['/home/complete-affirmation'], {queryParams: inputConfig});
        //
        // } else {
        //     await this.router.navigate(['/home/consentForm'], {queryParams: inputConfig});
        // }
    }

    async showCustomForm(form: any) {
        const inputConfig = {
            parentId: null,
            childId: null,
            mode: 'display',
            unique_id: form.unique_id
        };
        await this.router.navigate(['/home/requestFrom'], {queryParams: inputConfig});
    }

    async editCustomForm(form: any) {
        await this.router.navigate(['/home/custom-form-creator'], {queryParams: {mode: true, uniqueId: form.unique_id}});
    }

    async duplicate(form: any) {
        try {
            await this.consentsFormService.duplicateForm(form.unique_id);
            this.duplicateFormEmit.emit();
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        }
    }

    async editForm(form: any) {
        await this.router.navigate(['/home/form-creator'], {
            queryParams: {
                mode: true,
                uniqueId: form.unique_id,
                consent: true
            }
        });
    }

    deleteForm(form: any) {
        const confirmDialog = this.dialog.open(ConfirmDialogComponent, {
            data: {
                type: 'delete',
                icon: 'delete',
                title: +this.mode !== 2 ? 'Διαγραφή δήλωσης' : 'Διαγραφή ανακοίνωσης',
                message: +this.mode !== 2 ? `Είστε σίγουροι ότι θέλετε να διαγράψετε την δήλωση?` : `Είστε σίγουροι ότι θέλετε να διαγράψετε την ανακοίνωση?`
            }
        });

        confirmDialog.afterClosed().subscribe(async (response) => {
            if (response) {
                try {
                    let deleteRequest: any;
                    if (+this.mode === 2) {
                        deleteRequest = await this.commonService.deleteItem(`forms?formId=${form.id}`);
                    } else {
                        deleteRequest = await this.commonService.deleteItem(`forms/custom?formId=${form.id}`);
                    }

                    if (deleteRequest.status === 200) {
                        this.deleteFormEmit.emit(form.id);
                    }
                } catch (e) {
                    this.toastMessagesService.toastErrorMessage(e.message);
                }
            }
        });
    }

    navigateToStudentList(form: any) {
        this.dialog.open(StudentsDialogComponent, {
            width: '1200px',
            height: '650px',
            data: {
                mode: this.mode,
                unique_id: form.unique_id
            }
        });
    }

    async editAnnouncement(form: any) {
        await this.router.navigate(['/home/form-creator'], {
            queryParams: {
                mode: 'true',
                uniqueId: form.unique_id,
                consent: 'false'
            }
        });
    }

    publish(form: any) {

    }
}
